import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

const pad = n => String(n).padStart(2, "0");
export const fmtDate = (d) => { if (!d) return "—"; const x = new Date(d); return isNaN(x) ? d : `${pad(x.getDate())}/${pad(x.getMonth() + 1)}/${x.getFullYear()}`; };
export const fmtDateTime = (d) => { if (!d) return "—"; const x = new Date(d); return isNaN(x) ? d : `${fmtDate(x)} ${x.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}`; };
export const fmtRupee = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x.msg).join(", ");
  if (!e?.response) return "Network connection failed. Please check your connection and try again.";
  if (e.response.status === 413) return "File is too large for the server. Choose an audio file under 30 MB.";
  if (e.response.status >= 500) return "Server could not finish the upload. Please retry; if it repeats, contact support with the time of upload.";
  return `Upload failed (error ${e.response.status}). Please retry.`;
};

export const downloadFile = async (url, params, filename) => {
  const { data, headers } = await http.get(url, { params, responseType: "blob" });
  const name = filename || (headers["content-disposition"] || "").match(/filename="?([^"]+)"?/)?.[1] || "download";
  const href = URL.createObjectURL(data);
  const a = Object.assign(document.createElement("a"), { href, download: name });
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(href);
};

export const timeLeft = (iso) => {
  if (!iso) return null;
  const diff = new Date(iso).getTime() - Date.now();
  if (diff < 0) return { text: "Overdue", tone: "danger", ms: diff };
  const hrs = Math.floor(diff / 3600000);
  const mins = Math.floor((diff % 3600000) / 60000);
  if (hrs >= 48) return { text: `${Math.floor(hrs/24)} days left`, tone: "success", ms: diff };
  if (hrs >= 12) return { text: `${hrs}h left`, tone: "success", ms: diff };
  return { text: `${hrs}h ${mins}m left`, tone: "warning", ms: diff };
};
